// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__33Y2K","name":"Header_name__hXO4x","birthday":"Header_birthday__pOO9B","skeleton":"Header_skeleton__uC0vN"};